<template>
  <div :class="['item_list',detailData.viewClass]" :style="boxStyle">
      <div v-for="(item, index) in detailData.content.imgList" :key="index" class="floatimg-item" :style="item.style" :class="getBgClass(index,item)">
          <img v-if="item.src" class="floatimg-image" :src="item.imgSrc" />
          <img class="play_btn" v-if="item.actionType == 10" :src="`${fixImg}/minipro/play.png`" />
      </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'MultiImg',
  props: {},
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
        content: {
          imgList: []
        }
      },
      pattern: {},
    }
  },
  watch: {
  },
  computed: {
    boxStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
        "width": `${364 - (this.pattern.margin * 2)}px`,
        "height": `${364 - (this.pattern.margin * 2)}px`,
      }
    },
  },
  methods: {
    getBgClass(index,item){
      if(item.src){
        return ''
      }
      let layoutType = this.pattern.layoutType
      if((layoutType==0&&index==0)||(layoutType!=0&&index==1)){
        return "highBg bg"
      }else{
        return "bg"
      }
    },
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      console.log("MultiImg----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.item_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .floatimg-item {
        // margin-top: 20rpx;
        position: relative;
        &.bg{
          background-image: url("../image/imgDefault.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          &.highBg{
            background-size: 100% 50%;
            background-position: 0 50%;
            background-color: #f7f7f7;
          }
        }
        .floatimg-image{
            width: 100%;
            height: 100%;
        }
        .play_btn {
            position: absolute;
            width: 44px;
            height: 44px;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 2;
        }
    }
}
.lort, .ltro{
    width: 364px;
    height: 364px;
    position: relative;
}
.ltro .floatimg-item{

    &:nth-of-type(3) {
        position: absolute;
        left: 0px;
        bottom: 0;
    }
}
.lort .floatimg-item{
    &:nth-of-type(3) {
        position: absolute;
        bottom: 0;
        right: 0px;
    }
}
</style>
